import { useEffect, useState } from "react";
import { WalletCards, ShoppingBag, Clock3, UtensilsCrossed, Landmark } from "lucide-react";
import { http, rupiah } from "@/lib/api";
import AdminShell, { PageHead } from "@/components/AdminShell";

const STATUS = { new: "Baru", preparing: "Diproses", ready: "Siap", completed: "Selesai", cancelled: "Batal" };

export default function Dashboard() {
  const [m, setM] = useState(null);
  const [orders, setOrders] = useState([]);

  async function load() {
    try {
      const [d, o] = await Promise.all([http.get("/admin/dashboard"), http.get("/admin/orders")]);
      setM(d.data); setOrders(o.data);
    } catch {}
  }
  useEffect(() => { load(); const t = setInterval(load, 6000); return () => clearInterval(t); }, []);

  const cards = m ? [
    { label: "Revenue Hari Ini", value: rupiah(m.revenue_today), Icon: WalletCards },
    ...(m.finance
      ? [{ label: "Saldo Usaha", value: rupiah(m.finance.balance), Icon: Landmark }]
      : []),
    { label: "Pesanan Hari Ini", value: m.orders_today, Icon: ShoppingBag },
    { label: "Pending", value: m.pending_orders, Icon: Clock3 },
    { label: "Meja Aktif", value: m.active_tables, Icon: UtensilsCrossed },
  ] : [];

  return (
    <AdminShell>
      <PageHead eyebrow="Overview" title="Dashboard" desc="Ringkasan aktivitas kedai hari ini." />
      <div className={`grid grid-cols-2 gap-3 ${m?.finance ? "lg:grid-cols-5" : "lg:grid-cols-4"}`}>
        {cards.map(({ label, value, Icon }) => (
          <div key={label} className="rounded-3xl border border-border bg-card p-5">
            <div className="grid h-10 w-10 place-items-center rounded-xl bg-primary/15 text-primary"><Icon size={18} /></div>
            <div className="mt-4 text-xs font-semibold text-muted-foreground">{label}</div>
            <div className="mt-1 font-heading text-2xl font-extrabold tracking-tight text-card-foreground">{value}</div>
          </div>
        ))}
      </div>
      <h2 className="mb-3 mt-8 font-heading text-xl font-extrabold tracking-tight">Pesanan Terbaru</h2>
      <div className="space-y-2">
        {orders.slice(0, 10).map((o) => (
          <div key={o.id} className="flex items-center justify-between rounded-2xl border border-border bg-card p-4">
            <div className="min-w-0">
              <div className="truncate font-heading text-sm font-bold text-card-foreground">{o.id}</div>
              <div className="text-xs text-muted-foreground">{o.customer_name} · {o.table_name}</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="rounded-full bg-muted px-2.5 py-1 text-[10px] font-bold uppercase text-muted-foreground">{STATUS[o.status]}</span>
              <b className="font-heading text-sm">{rupiah(o.total)}</b>
            </div>
          </div>
        ))}
        {orders.length === 0 && <div className="rounded-2xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground">Belum ada pesanan.</div>}
      </div>
    </AdminShell>
  );
}
